"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_BOOKINGS_VIEWER_SCRIPT_DNS = 'https://590d4d7ac1594ef8a4201c7c5e82d8da@sentry.io/1399205';
exports.SENTRY_BOOKINGS_RUNNING_ENVIRONMENT = 'ooi-viewer-script';
//# sourceMappingURL=sentry.const.js.map